import { useEffect, useState } from 'react'
import { Link } from '@tanstack/react-router'
import { Header } from 'components/layout/header'
import { Main } from 'components/layout/main'
import { Search } from 'components/search'
import { Button } from 'components/ui/button'
import { GenericDataTable } from 'helpers/generic-data-table'
import { liveEventsColumns } from 'helpers/live-events-columns'
import { Loader, Plus } from 'lucide-react'
import {
  deleteLiveEvent,
  fetchLiveEvents,
  setLiveEventScreen,
} from 'store/liveEvents/liveEventsSlice'
import { useAppDispatch, useAppSelector } from 'store/store'

const LiveEventsPage = () => {
  const dispatch = useAppDispatch()
  const { loading, events, totalPages } = useAppSelector((s) => s.liveEvents)
  const [pageIndex, setPageIndex] = useState(0) // table is 0-based, API is 1-based

  useEffect(() => {
    dispatch(fetchLiveEvents(pageIndex + 1))
  }, [dispatch, pageIndex])

  return (
    <>
      <Header>
        <div className='ml-auto flex items-center space-x-4'>
          <Search />
        </div>
      </Header>
      <Main>
        <div className='mb-4 flex flex-wrap items-center justify-between gap-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>Eventi live</h2>
            <p className='text-muted-foreground'>
              Minigioco brandizzato con QR, maxischermo e classifiche.
            </p>
          </div>
          <Button asChild>
            <Link to='/eventi-live/nuovo'>
              <Plus className='mr-1 h-4 w-4' /> Nuovo evento
            </Link>
          </Button>
        </div>
        {loading && !events.length ? (
          <Loader className='h-5 w-5 animate-spin' />
        ) : (
          <GenericDataTable
            columns={liveEventsColumns({
              onScreenChange: (id, enabled) =>
                dispatch(setLiveEventScreen({ id, enabled })),
              onDelete: (id) => dispatch(deleteLiveEvent(id)),
            })}
            data={events}
            pageCount={totalPages}
            pageIndex={pageIndex}
            pageSize={20}
            onPageIndexChange={setPageIndex}
          />
        )}
      </Main>
    </>
  )
}

export default LiveEventsPage
